import { useSelector, useDispatch } from 'react-redux';
import { SlideOutWrapper } from './SlideOutWrapper';
import BaseDealLender from '../baseDealLender/BaseDealLender';
import { UnsavedChangesConfirmationModal, useGetDrawerWidth, useUnsavedChangesModal } from '@makemydeal/dr-dash-components';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { lenderReturnToOfferClicked } from '@makemydeal/dr-dash-store/actions/deskingActionCreators';
import { getLenderProbabilities } from '@makemydeal/dr-dash-store/selectors/deskingSelectors';
import { getVehicleAnalyticsPayload } from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import { getReturnToOfferButton } from '@makemydeal/dr-shared-ui-utils';

import type { SlideOutComponentProps } from '../../types';

export const LenderSlideOut = ({ isOpen, onClose }: SlideOutComponentProps) => {
    const dispatch = useDispatch();
    const panelWidth = useGetDrawerWidth();

    const lender = useSelector(offerReduxSelectors.getCreditDecisionLender);
    const vehicleAnalyticsPayload = useSelector(getVehicleAnalyticsPayload);
    const lenderProbabilities = useSelector(getLenderProbabilities);

    const {
        isDirtyRef: isLenderFormDirtyRef,
        showConfirmationModal,
        handleClose,
        handleCancelChanges,
        handleContinueEditing
    } = useUnsavedChangesModal({
        savedData: lender,
        onClose
    });

    return (
        <>
            <SlideOutWrapper
                title={'Lender'}
                isOpen={isOpen}
                onClose={handleClose}
                panelWidth={panelWidth}
                testId="tab-slideout-lender"
                footer={getReturnToOfferButton(() => {
                    const lenderAnalytics = lenderProbabilities?.map((lp) => ({
                        lenderId: lp.lenderId ?? lp.lender,
                        lenderName: lp.lender,
                        loanLikelihood: lp.approveProb,
                        buyRate: lp.buyRate,
                        // ILS-powered backend limit (dc-mv-279).
                        backendLimit: lp.backendLimit
                    }));
                    dispatch(lenderReturnToOfferClicked(vehicleAnalyticsPayload, lenderAnalytics)); // dc-mv-279: Analytics tag
                    handleClose();
                })}
            >
                <BaseDealLender isInsideSlideOut={true} isLenderFormDirtyRef={isLenderFormDirtyRef} />
            </SlideOutWrapper>
            <UnsavedChangesConfirmationModal
                show={showConfirmationModal}
                onCancelChanges={handleCancelChanges}
                onContinueEditing={handleContinueEditing}
            />
        </>
    );
};
